export default "__VITE_ASSET__B4tWPFCc__"